import { render, staticRenderFns } from "./v-navbar-notifications-item.vue?vue&type=template&id=25c8a00c&scoped=true&"
import script from "./v-navbar-notifications-item.vue?vue&type=script&lang=js&"
export * from "./v-navbar-notifications-item.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-notifications-item.vue?vue&type=style&index=0&id=25c8a00c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8a00c",
  null
  
)

export default component.exports